import React from 'react';
import SIcon from './SIcon';
import { faMinusCircle } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faMinusCircle} fa />;

export default Icon;
